import type { ReactNode } from 'react'
import { useIsAdmin } from '@/hooks/useIsAdmin'

interface AdminOnlyProps {
  children: ReactNode
  fallback?: ReactNode
}

/**
 * Wrapper component that only renders children if the current user is an admin.
 * Renders nothing (or optional fallback) while loading or for non-admins.
 */
export function AdminOnly({ children, fallback = null }: AdminOnlyProps) {
  const { isAdmin, isLoading } = useIsAdmin()

  if (isLoading) {
    return null
  }

  if (!isAdmin) {
    return <>{fallback}</>
  }

  return <>{children}</>
}
